import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';
import AdminNavbar from './AdminNavbar';
import { AdminThemeProvider, useAdminTheme } from '../context/AdminThemeContext';

// Internal Layout Component
const InnerLayout: React.FC = () => {
  const navigate = useNavigate();
  const { colors } = useAdminTheme();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (!token) {
      navigate('/pit-control');
    }
  }, [navigate]);

  return (
    <div className={`min-h-screen flex transition-colors duration-500 ${colors.mainBg} relative`}>
      
      {/* Mobile Overlay (Click outside to close sidebar) */}
      {isSidebarOpen && (
        <div 
          className="fixed inset-0 bg-black/50 z-40 lg:hidden backdrop-blur-sm transition-opacity"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      {/* 1. Sidebar (Passed open state) */}
      <AdminSidebar 
        isOpen={isSidebarOpen} 
        onClose={() => setIsSidebarOpen(false)} 
      />

      {/* Main Content Wrapper */}
      <div className="flex-1 flex flex-col min-w-0 lg:ml-64 transition-all duration-300">
        
        {/* 2. Navbar (Passed toggle function) */}
        <AdminNavbar onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)} />

        {/* 3. Main Content */}
        <main className="p-4 md:p-8 pt-24 md:pt-24 min-h-screen animate-fade-in-up overflow-x-hidden">
          <Outlet /> 
        </main>
      </div>
    </div>
  );
};

// Wrap everything in Provider
const AdminLayout: React.FC = () => {
  return (
    <AdminThemeProvider>
      <InnerLayout />
    </AdminThemeProvider>
  );
};

export default AdminLayout;